import { render, staticRenderFns } from "./curv.vue?vue&type=template&id=4d6fd9ec&scoped=true"
import script from "./curv.vue?vue&type=script&lang=js"
export * from "./curv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6fd9ec",
  null
  
)

export default component.exports